module.exports = __webpack_public_path__ + "Thav-candle.jpg?4b4cba934bf0c9f8248677835c3a47cb";


//////////////////
// WEBPACK FOOTER
// ./src/assets/thav/Thav-candle.jpg
// module id = 60
// module chunks = 0